import { useContext } from 'react';
import type { AnalyticsService } from './AnalyticsService';
import { AnalyticsContext } from './AnalyticsContext';

export const useAnalytics = (): AnalyticsService => {
  const context = useContext(AnalyticsContext);
  if (!context) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }
  return context;
};
